import apiClient from './ApiClient';

export const getApplicationFromId = async (id, passkey) => {
  const res = await apiClient.get(
    `/portal/vendor/shareable/application/${id}/${passkey}`,
  );
  return res.data;
};

export const addDocument = async (file, applicationId, docType) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('applicationId', applicationId || 0);
  formData.append('name', `${docType} Upload`);
  formData.append('description', `Upload of ${docType}`);
  formData.append('type', docType);
  formData.append('verificationStatus', 'PENDING');
  formData.append('comments', '');

  const headers = {
    'Content-Type': 'multipart/form-data',
  };

  return apiClient.post('/portal/vendor/shareable/upload', formData, {
    headers,
  });
};

export const addDocumentWithNameDesc = async (
  file,
  applicationId,
  docType,
  name,
  description,
  comments,
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('applicationId', applicationId || 0);
  formData.append('name', `${name} Upload`);
  formData.append('description', `${description}`);
  formData.append('type', docType);
  formData.append('verificationStatus', 'PENDING');
  formData.append('comments', `${comments}`);

  const headers = {
    'Content-Type': 'multipart/form-data',
  };

  return apiClient.post('/portal/vendor/shareable/upload', formData, {
    headers,
  });
};
